import axios from "axios";
import i18n from "../../../i18n";

const actions = {
  getAllInstructionCategories(context) {
    return axios
      .get("instructionCategory")
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },
  createInstructionCategory(context, value) {
    return axios
      .post("instructionCategory", value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("dangerousGoods.storageLocation.createdMessage", {
            name: r.data.name,
          })
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  deleteInstructionCategory(context, val) {
    return axios
      .delete("instructionCategory/" + val.id)
      .then(function (res) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("dangerousGoods.storageLocation.deletedMessage")
        );
        return res;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  updateInstructionCategory(context, value) {
    return axios
      .put("instructionCategory/" + value.id, value)
      .then(function (r) {
        context.commit(
          "CREATE_SNACKBAR",
          i18n.t("dangerousGoods.storageLocation.updatedMessage", {
            name: r.data.name,
          })
        );
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getSingleInstructionCategory(context, id) {
    return axios
      .get("instructionCategory/" + id)
      .then(function (r) {
        return r.data;
      })
      .catch(function (e) {
        context.dispatch("triggerError", e);
      });
  },

  getInstructionCategoryCounts(context) {
    return axios
      .get("instructionCategory/counts")
      .then((r) => r.data.counts || {})
      .catch((e) => context.dispatch("triggerError", e));
  },
};

export default actions;
